export default __webpack_public_path__ + "static/media/76t.954a3088.jpg";